import { render, staticRenderFns } from "./SolicitudesModulo.vue?vue&type=template&id=436629cf"
import script from "./SolicitudesModulo.vue?vue&type=script&lang=js"
export * from "./SolicitudesModulo.vue?vue&type=script&lang=js"
import style0 from "./SolicitudesModulo.vue?vue&type=style&index=0&id=436629cf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports